import { render } from "./SprintDeleteMark.vue?vue&type=template&id=f36deffc&scoped=true"
import script from "./SprintDeleteMark.vue?vue&type=script&lang=js"
export * from "./SprintDeleteMark.vue?vue&type=script&lang=js"

import "./SprintDeleteMark.vue?vue&type=style&index=0&id=f36deffc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f36deffc"],['__file',"src/components/SprintDeleteMark.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f36deffc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f36deffc', __exports__)) {
    api.reload('f36deffc', __exports__)
  }
  
  module.hot.accept("./SprintDeleteMark.vue?vue&type=template&id=f36deffc&scoped=true", () => {
    api.rerender('f36deffc', render)
  })

}


export default __exports__